<template>
  <div>
    <!-- <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">To</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <vue-input-tag :tags.sync="innerEmailer.toEmails"
              @new-tag="newEmailInput"
              validate="email"
              tabindex="1" />
            <span class="help is-danger"
              v-if="!isValidToEmail">Invalid email address</span>
            <span class="help is-info"
              v-if="showToHint">Press &lt;Enter&gt; key to add email address</span>
          </div>
        </div>
        <div class="control">
          <button class="button"
            @click="toggleCcBcc"
            tabindex="-1">
            <span class="icon is-small is-left">
              <i class="mdi mdi-24px"
                :class="[ showCcBcc ? 'mdi-chevron-up' : 'mdi-chevron-down' ]" />
            </span>
          </button>
        </div>
      </div>
    </div> -->
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">To</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <multiselect id="toemails-multiselect"
              v-model="selectedToEmails"
              :options="availableToEmails"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="true"
              :preserve-search="true"
              :taggable="true"
              placeholder="Enter email address or search"
              tag-placeholder="Press enter to add email"
              label="email"
              track-by="email"
              :show-labels="false"
              @tag="addEmailTag"
              @search-change="getAssetsEmailAddresses"
              :searchable="true"
              :internal-search="false">
              <template slot="option"
                slot-scope="props">
                <span class="tag is-pulled-right"
                  :class="{'is-success' : props.option.assetTypeName === 'Customer', 'is-info' : props.option.assetTypeName === 'Insurer'}">
                  {{ props.option.assetTypeName }}
                </span>
                <span>{{ props.option.name }} &lt;{{ props.option.email }}&gt;</span>
              </template>
              <template slot="tag"
                slot-scope="props">
                <span class="tag is-primary multiselect-email-tag">
                  {{ props.option.email }}
                  <button class="delete is-small"
                    @click="props.remove(props.option)" />
                </span>
              </template>
            </multiselect>
            <!-- <pre class="language-json"><code>{{ selectedToEmails }}</code></pre> -->
            <span class="help is-danger"
              v-if="!isValidToEmail">Invalid email address</span>
            <span class="help is-info"
              v-if="showToHint">Press &lt;Enter&gt; key to add email address</span>
          </div>
        </div>
        <div class="control">
          <button class="button"
            @click="toggleCc"
            tabindex="-1">
            <span class="icon is-small is-left">
              <i class="mdi mdi-24px"
                :class="[ showCc ? 'mdi-chevron-up' : 'mdi-chevron-down' ]" />
            </span>
            <span>Cc</span>
          </button>
          <button class="button"
            @click="toggleBcc"
            tabindex="-1"
            style="margin-left: 0.5em;">
            <span class="icon is-small is-left">
              <i class="mdi mdi-24px"
                :class="[ showBcc ? 'mdi-chevron-up' : 'mdi-chevron-down' ]" />
            </span>
            <span>Bcc</span>
          </button>
        </div>
      </div>
    </div>
    <div v-show="showCc"
      class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Cc</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <!-- <vue-input-tag :tags.sync="innerEmailer.ccEmails"
              @new-tag="newCcEmailInput"
              validate="email" /> -->
            <multiselect id="ccemails-multiselect"
              v-model="selectedCcEmails"
              :options="availableCcEmails"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="true"
              :preserve-search="true"
              :taggable="true"
              placeholder="Enter email address or search"
              tag-placeholder="Press enter to add email"
              label="email"
              track-by="email"
              :show-labels="false"
              @tag="addEmailTag"
              @search-change="getAssetsEmailAddresses"
              :searchable="true"
              :internal-search="false">
              <template slot="option"
                slot-scope="props">
                <span class="tag is-pulled-right"
                  :class="{'is-success' : props.option.assetTypeName === 'Customer', 'is-info' : props.option.assetTypeName === 'Insurer'}">
                  {{ props.option.assetTypeName }}
                </span>
                <span>{{ props.option.name }} &lt;{{ props.option.email }}&gt;</span>
              </template>
              <template slot="tag"
                slot-scope="props">
                <span class="tag is-primary multiselect-email-tag">
                  {{ props.option.email }}
                  <button class="delete is-small"
                    @click="props.remove(props.option)" />
                </span>
              </template>
            </multiselect>
            <!-- <span class="help is-danger"
              v-if="!isValidCcEmail">Invalid email address</span>
            <span class="help is-info"
              v-if="showCcHint">Press &lt;Enter&gt; key to add email address</span> -->

          </div>
        </div>
      </div>
    </div>
    <div v-show="showBcc"
      class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Bcc</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <!-- <vue-input-tag :tags.sync="innerEmailer.bccEmails"
              @new-tag="newBccEmailInput"
              validate="email" /> -->
            <multiselect id="bccemails-multiselect"
              v-model="selectedBccEmails"
              :options="availableBccEmails"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="true"
              :preserve-search="true"
              :taggable="true"
              placeholder="Enter email address or search"
              tag-placeholder="Press enter to add email"
              label="email"
              track-by="email"
              :show-labels="false"
              @tag="addEmailTag"
              @search-change="getAssetsEmailAddresses"
              :searchable="true"
              :internal-search="false">
              <template slot="option"
                slot-scope="props">
                <span class="tag is-pulled-right"
                  :class="{'is-success' : props.option.assetTypeName === 'Customer', 'is-info' : props.option.assetTypeName === 'Insurer'}">
                  {{ props.option.assetTypeName }}
                </span>
                <span>{{ props.option.name }} &lt;{{ props.option.email }}&gt;</span>
              </template>
              <template slot="tag"
                slot-scope="props">
                <span class="tag is-primary multiselect-email-tag">
                  {{ props.option.email }}
                  <button class="delete is-small"
                    @click="props.remove(props.option)" />
                </span>
              </template>
            </multiselect>
            <span class="help is-danger"
              v-if="!isValidBccEmail">Invalid email address</span>
            <span class="help is-info"
              v-if="showBccHint">Press &lt;Enter&gt; key to add email address</span>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showCc || showBcc"
      class="is-divider" />
    <div v-show="false"
      class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">From</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <input type="text"
              class="input"
              placeholder="">
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Reply To</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <input v-model="replyToMessageId"
              type="text"
              class="input"
              placeholder=""
              readonly>
          </div>
        </div>
      </div>
    </div> -->
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Subject</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <input v-model="innerEmailer.subject"
              type="text"
              class="input"
              placeholder="Subject">
          </div>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Message</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <textarea v-model="innerEmailer.message"
              class="textarea"
              rows="10"
              placeholder="" />
          </div>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Attachments</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <vue-input-tag :tags="combinedAttachments"
              @remove-tag="handleRemovedTag"
              tag-colour="is-turquoise"
              :allow-input="false">
              <template #tag="{ tag }">
                <span>{{ tag.fileName }}</span>
                <span v-if="tag.fileSize > 0"
                  class="ml-1 is-size-7 has-text-grey">
                  ({{ formatFileSize(tag.fileSize) }})
                </span>
              </template>
            </vue-input-tag>
            <div v-if="combinedAttachments.length > 0"
              class="mt-2">
              <!-- File count and size info -->
              <div class="level is-mobile mb-1">
                <div class="level-left">
                  <div class="level-item">
                    <span class="has-text-grey is-size-7">
                      {{ combinedAttachments.length }} files - {{ formatFileSize(totalAttachmentSize) }} total
                    </span>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <span class="has-text-grey is-size-7">
                      {{ formatFileSize(totalAttachmentSize) }} / 25 MB
                    </span>
                  </div>
                </div>
              </div>

              <!-- Progress bar -->
              <div class="progress-container mb-2">
                <progress class="progress is-small"
                  :class="{ 'is-danger': isAttachmentSizeExceeded, '': !isAttachmentSizeExceeded }"
                  :value="totalAttachmentSize"
                  :max="25 * 1024 * 1024">
                  {{ Math.round((totalAttachmentSize / (25 * 1024 * 1024)) * 100) }}%
                </progress>
              </div>

              <!-- Warning message -->
              <div v-if="isAttachmentSizeExceeded"
                class="attachment-warning">
                <span class="icon is-large mr-1">
                  <i class="mdi mdi-alert mdi-24px" />
                </span>
                <span>Total attachment size ({{ formatFileSize(totalAttachmentSize) }}) exceeds the 25MB limit.<br>
                  Please remove some files.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FocusInserted } from '@/components/directives'
import VueInputTag from '@/components/VueInputTag'
import EmailService from './EmailService'
import Multiselect from 'vue-multiselect'
import _debounce from 'lodash.debounce'
import { AssetTypes } from '@/enums'
// import _isEmpty from 'lodash/isEmpty'
import _cloneDeep from 'lodash/cloneDeep'
import QuoteService from '@/views/quote/QuoteService'

/* eslint-disable */
const emailValidator = new RegExp(
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
)
/* eslint-enable */

export default {
  name: 'VueEmail',
  directives: {
    FocusInserted
  },
  components: {
    VueInputTag,
    Multiselect
  },
  props: {
    value: null,
    toEmails: {
      type: Array,
      default: () => []
    },
    ccEmails: {
      type: Array,
      default: () => []
    },
    bccEmails: {
      type: Array,
      default: () => []
    },
    subject: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    attachments: {
      type: Array,
      default: () => []
    },
    reportBytes: {
      type: ArrayBuffer,
      default: null
    },
    reportName: {
      type: String,
      default: ''
    },
    reportContentType: {
      type: String,
      default: ''
    },
    quoteImageAttachments: {
      type: Array,
      default: function () {
        return []
      }
    },
    quoteAttachments: {
      type: Array,
      default: function () {
        return []
      }
    },
    assetId: {
      type: String,
      default: ''
    },
    assetType: {
      type: String,
      default: ''
    },
    replyToMessageId: {
      type: String,
      default: ''
    },
    isShowCc: {
      type: Boolean,
      default: false
    },
    isShowBcc: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerEmailer: null,
      showCc: false,
      showBcc: false,
      isValidToEmail: true,
      showToHint: false,
      isValidCcEmail: true,
      showCcHint: false,
      isValidBccEmail: true,
      showBccHint: false,
      innerAttachments: [],
      selectedToEmails: [],
      selectedCcEmails: [],
      selectedBccEmails: [],
      emailFilter: {
        assetId: this.assetId,
        search: '',
        assetTypes: [AssetTypes.Customer, AssetTypes.Insurer],
        pageIndex: 1,
        pageSize: 20
      },
      availableToEmails: [],
      availableCcEmails: [],
      availableBccEmails: [],
      //attachmentsTag: []
      errors: []
    }
  },
  computed: {
    totalAttachmentSize() {
      let totalSize = 0

      if (this.innerEmailer && Array.isArray(this.innerEmailer.attachments)) {
        for (const att of this.innerEmailer.attachments) {
          if (typeof att === 'object' && att.fileSize) {
            totalSize += att.fileSize || 0
          }
        }
      }

      if (this.innerEmailer && Array.isArray(this.innerEmailer.customAttachments)) {
        for (const att of this.innerEmailer.customAttachments) {
          if (att && att.fileBytes) {
            totalSize += att.fileBytes.byteLength || att.fileSize || 0
          }
        }
      }

      if (this.innerEmailer && Array.isArray(this.innerEmailer.quoteAttachments)) {
        for (const att of this.innerEmailer.quoteAttachments) {
          if (att && (att.originalFileSize || att.fileSize)) {
            totalSize += att.originalFileSize || att.fileSize || 0
          }
        }
      }

      if (this.innerEmailer && Array.isArray(this.innerEmailer.quoteImageAttachments)) {
        for (const img of this.innerEmailer.quoteImageAttachments) {
          if (img && (img.originalFileSize || img.fileSize)) {
            totalSize += img.originalFileSize || img.fileSize || 0
          }
        }
      }

      return totalSize
    },
    isAttachmentSizeExceeded() {
      const maxSizeBytes = 25 * 1024 * 1024 // 25MB in bytes
      return this.totalAttachmentSize > maxSizeBytes
    },
    attachmentSizeMessage() {
      if (this.isAttachmentSizeExceeded) {
        return `Total attachment size (${this.formatFileSize(
          this.totalAttachmentSize
        )}) exceeds the 25MB limit. Please remove some attachments to send the email.`
      }
      return `Total attachment size: ${this.formatFileSize(this.totalAttachmentSize)}`
    },
    canSendEmail() {
      const hasToEmails = this.selectedToEmails && this.selectedToEmails.length > 0
      const withinSizeLimit = !this.isAttachmentSizeExceeded
      return hasToEmails && withinSizeLimit
    },
    combinedAttachments() {
      // Combine attachments, customAttachments, and quoteAttachments, avoid duplicates by fileName or string
      const attachmentObjects = []
      const processedNames = []

      if (this.innerEmailer && Array.isArray(this.innerEmailer.attachments)) {
        for (const att of this.innerEmailer.attachments) {
          if (typeof att === 'string') {
            if (!processedNames.includes(att)) {
              processedNames.push(att)
              attachmentObjects.push({ fileName: att, fileSize: 0 })
            }
          } else if (att && att.fileName && !processedNames.includes(att.fileName)) {
            const quoteImageIndex = this.innerEmailer.attachments.findIndex((img) => img.fileName === att.fileName)
            if (quoteImageIndex !== -1) {
              const quoteImage = this.innerEmailer.attachments[quoteImageIndex]
              if (!processedNames.includes(quoteImage.fileName)) {
                processedNames.push(quoteImage.fileName)
                attachmentObjects.push({
                  fileName: quoteImage.fileName,
                  fileSize: quoteImage.originalFileSize || quoteImage.fileSize || 0
                })
              }
            } else {
              processedNames.push(att.fileName)
              attachmentObjects.push({ fileName: att.fileName, fileSize: 0 })
            }
          }
        }
      }
      if (this.innerEmailer && Array.isArray(this.innerEmailer.customAttachments)) {
        for (const att of this.innerEmailer.customAttachments) {
          if (att && att.fileName && !processedNames.includes(att.fileName)) {
            processedNames.push(att.fileName)
            const fileSizeBytes = att.fileBytes ? att.fileBytes.byteLength : 0
            attachmentObjects.push({
              fileName: att.fileName,
              fileSize: fileSizeBytes || att.fileSize || 0
            })
          }
        }
      }

      if (this.innerEmailer && Array.isArray(this.innerEmailer.quoteAttachments)) {
        for (const att of this.innerEmailer.quoteAttachments) {
          const name = att && (att.fileName || att.filename)
          if (name && !processedNames.includes(name)) {
            processedNames.push(name)
            attachmentObjects.push({
              fileName: name,
              fileSize: att.originalFileSize || att.fileSize || 0
            })
          }
        }
      }

      if (this.innerEmailer && Array.isArray(this.innerEmailer.quoteImageAttachments)) {
        for (const img of this.innerEmailer.quoteImageAttachments) {
          const name = img && (img.fileName || img.filename)
          if (name && !processedNames.includes(name)) {
            processedNames.push(name)
            attachmentObjects.push({
              fileName: name,
              fileSize: img.originalFileSize || img.fileSize || 0
            })
          }
        }
      }
      return attachmentObjects
    }
  },
  watch: {
    innerEmailer: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
        // Show Cc if there are any ccEmails
        if (newVal && Array.isArray(newVal.ccEmails)) {
          this.showCc = newVal.ccEmails.length > 0
        }
        // Show Bcc if there are any bccEmails
        if (newVal && Array.isArray(newVal.bccEmails)) {
          this.showBcc = newVal.bccEmails.length > 0
        }
      },
      deep: true
    },
    selectedToEmails: {
      handler: function (newVal, oldVal) {
        this.innerEmailer.toEmails.splice(0, this.innerEmailer.toEmails.length)
        this.innerEmailer.toEmails = this.selectedToEmails.map((e) => e.email)
      },
      deep: true
    },
    selectedCcEmails: {
      handler: function (newVal, oldVal) {
        this.innerEmailer.ccEmails.splice(0, this.innerEmailer.ccEmails.length)
        this.innerEmailer.ccEmails = this.selectedCcEmails.map((e) => e.email)
      },
      deep: true
    },
    selectedBccEmails: {
      handler: function (newVal, oldVal) {
        this.innerEmailer.bccEmails.splice(0, this.innerEmailer.bccEmails.length)
        this.innerEmailer.bccEmails = this.selectedBccEmails.map((e) => e.email)
      },
      deep: true
    },
    value: {
      handler: function (newVal, oldVal) {
        this.innerEmailer = newVal
      }
    },
    toEmails: {
      handler: function (newVal, oldVal) {
        if (oldVal && oldVal.length) {
          oldVal.forEach((email) => {
            const index = this.selectedToEmails.findIndex((i) => i.email === email)
            if (index !== -1) this.selectedToEmails.splice(index, 1)
          })
        }
        if (newVal && newVal.length) {
          newVal.forEach((email) => {
            const index = this.selectedToEmails.findIndex((i) => i.email === email)
            if (index === -1) this.selectedToEmails.push({ name: email, email: email })
          })
        }
      }
    },
    ccEmails: {
      handler: function (newVal, oldVal) {
        if (oldVal && oldVal.length) {
          oldVal.forEach((email) => {
            const index = this.selectedCcEmails.findIndex((i) => i.email === email)
            if (index !== -1) this.selectedCcEmails.splice(index, 1)
          })
        }
        if (newVal && newVal.length) {
          newVal.forEach((email) => {
            const index = this.selectedCcEmails.findIndex((i) => i.email === email)
            if (index === -1) this.selectedCcEmails.push({ name: email, email: email })
          })
        }
      }
    },
    bccEmails: {
      handler: function (newVal, oldVal) {
        if (oldVal && oldVal.length) {
          oldVal.forEach((email) => {
            const index = this.selectedBccEmails.findIndex((i) => i.email === email)
            if (index !== -1) this.selectedBccEmails.splice(index, 1)
          })
        }
        if (newVal && newVal.length) {
          newVal.forEach((email) => {
            const index = this.selectedBccEmails.findIndex((i) => i.email === email)
            if (index === -1) this.selectedBccEmails.push({ name: email, email: email })
          })
        }
      }
    },
    message: {
      handler: function (newVal, oldVal) {
        this.innerEmailer.message = newVal
      }
    },
    subject: {
      handler: function (newVal, oldVal) {
        this.innerEmailer.subject = newVal
      }
    },
    isShowCc: {
      handler: function (newVal) {
        this.showCc = newVal
      }
    },
    isShowBcc: {
      handler: function (newVal) {
        this.showBcc = newVal
      }
    },
    canSendEmail: {
      handler: function (newVal) {
        this.$emit('validation-changed', {
          canSend: newVal,
          isAttachmentSizeExceeded: this.isAttachmentSizeExceeded,
          totalSize: this.totalAttachmentSize,
          errors: this.getValidationErrors()
        })
      },
      immediate: true
    }
  },
  created() {
    this.innerEmailer = _cloneDeep(this.value)
    this.populateEmails()
    this.emailFilter.assetTypes = this.innerEmailer.assetTypes
    this.refreshAttachmentList()
    this.getAssetsEmailAddresses()
    this.showCc = this.isShowCc
    this.showBcc = this.isShowBcc
  },
  mounted() {},
  methods: {
    populateEmails() {
      if (this.innerEmailer.toEmails) {
        this.innerEmailer.toEmails.forEach((email) =>
          this.selectedToEmails.splice(this.selectedToEmails.length, 1, {
            name: email,
            email: email
          })
        )
      }
      if (this.innerEmailer.ccEmails) {
        this.innerEmailer.ccEmails.forEach((email) =>
          this.selectedCcEmails.splice(this.selectedCcEmails.length, 1, {
            name: email,
            email: email
          })
        )
      }
      if (this.innerEmailer.bccEmails) {
        this.innerEmailer.bccEmails.forEach((email) =>
          this.selectedBccEmails.splice(this.selectedBccEmails.length, 1, {
            name: email,
            email: email
          })
        )
      }
    },
    toggleCc() {
      this.showCc = !this.showCc
    },
    toggleBcc() {
      this.showBcc = !this.showBcc
    },
    // toggleCcBcc() {
    //   this.showCcBcc = !this.showCcBcc
    // },
    getValidationErrors() {
      const errors = []
      if (!this.selectedToEmails || !this.selectedToEmails.length) {
        errors.push('Email address "To" is not provided.')
      }
      if (this.isAttachmentSizeExceeded) {
        errors.push(`Total attachment size (${this.formatFileSize(this.totalAttachmentSize)}) exceeds the 25MB limit.`)
      }
      return errors
    },
    isValid() {
      this.errors = this.getValidationErrors()
      return this.errors.length === 0
    },
    async send() {
      const isValid = this.isValid()
      if (!isValid) {
        this.$notification.error('Email', this.errors.join(' '))
        return
      }
      this.$showSpinner('Sending...')
      try {

        const formData = new FormData()
        const blob = new Blob([this.reportBytes], { type: this.reportContentType })
        if (this.innerEmailer.attachments.indexOf(this.reportName) > -1) {
          formData.append('report', blob, this.reportName)
        }
        // Add custom attachments as files
        if (Array.isArray(this.innerEmailer.customAttachments)) {
          for (const att of this.innerEmailer.customAttachments) {
            if (att && att.fileBytes && att.fileName) {
              const fileBlob = new Blob([att.fileBytes], { type: att.fileType || 'application/octet-stream' })
              formData.append('customAttachment', fileBlob, att.fileName)
            }
          }
        }
        this.innerEmailer.replyToMessageId = this.replyToMessageId
        formData.append('emailer', JSON.stringify(this.innerEmailer))
        formData.append('imageIds', JSON.stringify(this.quoteImageAttachments.map((i) => i.quoteImageId)))
        formData.append('quoteAttachmentIds', JSON.stringify(this.quoteAttachments.map((i) => i.quoteAttachmentId)))
        await EmailService.send(formData)
        this.$notification.openNotificationWithType('success', 'Send Email', 'Email sent successfully')
        this.$emit('sent')
        this.reset()
      } catch (e) {
        this.$notification.openMessageXhrError('Send Email', e)
      } finally {
        this.$hideSpinner()
      }
    },
    async sendExport(exportOptions, reportOptions, assessment = null) {
      this.$showSpinner('Sending...')
      try {
        const formData = new FormData()
        const blob = new Blob([this.reportBytes], { type: this.reportContentType })
        if (this.innerEmailer.attachments.indexOf(this.reportName) > -1) {
          formData.append('report', blob, this.reportName)
        }
        formData.append('emailer', JSON.stringify(this.innerEmailer))
        // formData.append('images', JSON.stringify(this.quoteImageAttachments))
        formData.append('imageIds', JSON.stringify(this.quoteImageAttachments.map((i) => i.quoteImageId)))
        if (assessment) {
          await QuoteService.requestAuthorityAssessment(this.innerEmailer.assetId, assessment)
        }
        await EmailService.sendExport(this.innerEmailer.assetId, exportOptions, reportOptions, formData)
        this.$notification.openNotificationWithType('success', 'Send Email', 'Email sent successfully')
        this.$emit('sent')
      } catch (e) {
        this.$notification.openMessageXhrError('Send Email', e)
      } finally {
        this.$hideSpinner()
      }
    },
    newEmailInput(newEmail) {
      this.isValidToEmail = newEmail === '' || emailValidator.test(newEmail)
      this.showToHint = this.isValidToEmail && newEmail !== ''
      this.$emit('new-email', newEmail !== '')
    },
    newCcEmailInput(newEmail) {
      this.isValidCcEmail = newEmail === '' || emailValidator.test(newEmail)
      this.showCcHint = this.isValidCcEmail && newEmail !== ''
      this.$emit('new-email', newEmail !== '')
    },
    newBccEmailInput(newEmail) {
      this.isValidBccEmail = newEmail === '' || emailValidator.test(newEmail)
      this.showBccHint = this.isValidBccEmail && newEmail !== ''
      this.$emit('new-email', newEmail !== '')
    },
    refreshAttachmentList(images) {
      // this.innerEmailer.attachments.splice(0, this.innerEmailer.attachments.length)
      // this.innerEmailer.attachments.splice(this.innerEmailer.attachments.length, 1, this.reportName)
      // // console.log(images)
      // if (!_isEmpty(images)) {
      //   for (var i = 0; i < images.length; i++) {
      //     this.innerEmailer.attachments.splice(this.innerEmailer.attachments.length, 1, images[i].fileName)
      //   }
      // }
    },
    addEmailTag(newEmail, id) {
      const isValidEmail = emailValidator.test(newEmail)
      // console.log('newTag', this.isValidToEmail, newEmail)
      if (isValidEmail) {
        const tag = {
          name: newEmail,
          email: newEmail,
          assetTypeName: 'None',
          assetType: 0
        }
        if (id === 'toemails-multiselect') {
          this.isValidToEmail = isValidEmail
          this.availableToEmails.push(tag)
          this.selectedToEmails.push(tag)
        } else if (id === 'ccemails-multiselect') {
          this.isValidCcEmail = isValidEmail
          this.availableCcEmails.push(tag)
          this.selectedCcEmails.push(tag)
        } else if (id === 'bccemails-multiselect') {
          this.isValidBccEmail = isValidEmail
          this.availableBccEmails.push(tag)
          this.selectedBccEmails.push(tag)
        }
      }
    },
    getAssetsEmailAddresses: _debounce(async function (query, id) {
      // console.log('getAssetsEmailAddresses', query, id)
      if (!this.$guid.validGuid(this.emailFilter.assetId)) {
        this.emailFilter.assetId = this.$guid.empty()
      }
      this.emailFilter.search = query || ''
      if (id === 'toemails-multiselect' || !id) {
        this.availableToEmails = await EmailService.getAssetsEmailAddresses(this.emailFilter)
      } else if (id === 'ccemails-multiselect') {
        this.availableCcEmails = await EmailService.getAssetsEmailAddresses(this.emailFilter)
      } else if (id === 'bccemails-multiselect') {
        this.availableBccEmails = await EmailService.getAssetsEmailAddresses(this.emailFilter)
      }
    }, 300),
    reset() {
      this.selectedToEmails.splice(0, this.selectedToEmails.length)
      this.selectedCcEmails.splice(0, this.selectedCcEmails.length)
      this.selectedBccEmails.splice(0, this.selectedBccEmails.length)
    },
    handleRemovedTag({ tag }) {
      // Clone the current emailer to avoid direct mutations
      const updatedEmailer = _cloneDeep(this.innerEmailer)

      // Extract the filename from the tag object
      const tagName = tag.fileName || tag

      // Remove from customAttachments if present
      if (updatedEmailer.customAttachments) {
        const customIndex = updatedEmailer.customAttachments.findIndex((att) => att && att.fileName && att.fileName.toLowerCase() === tagName.toLowerCase())
        if (customIndex !== -1) {
          updatedEmailer.customAttachments.splice(customIndex, 1)
        }
      }

      // Enhanced removal from quoteAttachments
      if (updatedEmailer.quoteAttachments) {
        // Find by multiple possible filename properties and case-insensitive comparison
        const quoteIndex = updatedEmailer.quoteAttachments.findIndex((att) => {
          if (!att) return false
          const attName = att.fileName || att.filename || att.name
          return attName && attName.toLowerCase() === tagName.toLowerCase()
        })

        if (quoteIndex !== -1) {
          // // Store the removed attachment details for potential undo
          // const removedAttachment = updatedEmailer.quoteAttachments[quoteIndex]
          // Remove the attachment
          updatedEmailer.quoteAttachments.splice(quoteIndex, 1)

          // Also remove from attachments array if present
          if (updatedEmailer.attachments) {
            const attachIndex = updatedEmailer.attachments.findIndex((att) => {
              if (typeof att === 'string') {
                return att.toLowerCase() === tagName.toLowerCase()
              }
              return att && att.fileName && att.fileName.toLowerCase() === tagName.toLowerCase()
            })
            if (attachIndex !== -1) {
              updatedEmailer.attachments.splice(attachIndex, 1)
            }
          }
        }
      }

      // Remove from regular attachments if present
      if (updatedEmailer.attachments) {
        const attachIndex = updatedEmailer.attachments.findIndex((att) => {
          if (typeof att === 'string') {
            return att.toLowerCase() === tagName.toLowerCase()
          }
          return att && att.fileName && att.fileName.toLowerCase() === tagName.toLowerCase()
        })
        if (attachIndex !== -1) {
          updatedEmailer.attachments.splice(attachIndex, 1)
        }
      }

      //Remove from quoteImageAttachments if present
      if (updatedEmailer.quoteImageAttachments) {
        const imageIndex = updatedEmailer.quoteImageAttachments.findIndex((img) => {
          if (!img) return false
          const imgName = img.fileName || img.filename || img.name
          return imgName && imgName.toLowerCase() === tagName.toLowerCase()
        })
        if (imageIndex !== -1) {
          updatedEmailer.quoteImageAttachments.splice(imageIndex, 1)
        }
      }

      // Update the emailer and emit change event
      this.innerEmailer = updatedEmailer
      //this.$emit('attachments-updated')
    },
    formatFileSize(sizeInBytes) {
      if (!sizeInBytes || sizeInBytes === 0) {
        return '0 KB'
      }

      const units = ['Bytes', 'KB', 'MB', 'GB']
      let size = sizeInBytes
      let unitIndex = 0

      while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024
        unitIndex++
      }

      return `${size.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`
    }
  }
}
</script>

<style lang="scss" scoped>
.is-divider {
  margin: 1.2em 0;
}
.multiselect-email-tag {
  margin-right: 0.5rem;
  text-transform: lowercase !important;
}

.progress-container {
  .progress {
    height: 8px;
    border-radius: 4px;

    &.is-danger::-webkit-progress-bar {
      background-color: #f5f5f5;
    }

    &.is-danger::-webkit-progress-value {
      background-color: #ff3860;
    }

    &.is-danger::-moz-progress-bar {
      background-color: #ff3860;
    }

    &.is-primary::-webkit-progress-value {
      background-color: #00d1b2;
    }

    &.is-primary::-moz-progress-bar {
      background-color: #00d1b2;
    }
  }
}

.attachment-warning {
  // background-color: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 8px 12px;
  color: #ff3860;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
}
</style>

<style lang="scss">
#toemails-multiselect,
#ccemails-multiselect,
#bccemails-multiselect {
  text-transform: lowercase !important;
}
</style>
